import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export class UrlCell extends GridCell {

  public render() {
    return <td>
      <div>
      <a id={`Title-${this.props.dataItem.id}`}
         href={this.props.dataItem[this.props.field]}
         target="_blank" rel="noopener noreferrer">
        {this.props.dataItem[this.props.field]}
      </a>
      </div>
    </td>
  }

}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/url_cell.tsx